// extracted by mini-css-extract-plugin
export default {"loader":"validation_loader__h5ufb","container":"validation_container__ITKU+"};